module.exports = __webpack_public_path__ + "img/active-28.7c3fb361.svg";